import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './core/services/language.service';
import { ServiceWorkerRegister } from './core/service-worker/serviceWorker';
import { environment } from 'src/environments/environment';
import { AuthService } from './core/services/auth.service';
import { Router } from '@angular/router';
import { extractTimeFromISOString } from './core/helpers/extractTimeFromISOString';
import { utcToLocalConversion } from './core/helpers/utcToLocaleConversion.helper';

@Component({
  selector: 'mega-store-factory-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Edwin';

  constructor(
    private languageService: LanguageService,
    private serviceWorker: ServiceWorkerRegister,
    translate: TranslateService,
    private authService: AuthService,
    private router: Router
  ) {
    if (!localStorage.getItem(environment.storageKey)) {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
    }
    this.languageService.initialize();
  }

  ngOnInit(): void {
    // Load user profile when app starts if token exists
    if (localStorage.getItem(environment.storageKey)) {
      this.authService.getProfile().subscribe({
        next: (res) => {
          if (res) {
            res.openingTime = extractTimeFromISOString(
              utcToLocalConversion(res.openingTime)
            );
            res.closingTime = extractTimeFromISOString(
              utcToLocalConversion(res.closingTime)
            );
            this.authService.profileDetails.next(res);
          }
        },
        error: () => {
          // If profile fetch fails, clear token and redirect to login
          localStorage.removeItem(environment.storageKey);
          this.router.navigate(['/auth/login']);
        }
      });
    }
    this.serviceWorker.publicApi();
  }
}
